var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex h-100 overflow-auto flex-column" },
    [
      _setup.formId
        ? _c(_setup.FormHeader, {
            key: "header-" + _setup.formId,
            attrs: {
              "form-id": _setup.formId,
              "show-add-btn": true,
              "show-save-and-close-btn": true,
              "show-save-btn": true,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.formId
        ? _c(_setup.FormNavAndForm, {
            key: "body-" + _setup.formId,
            attrs: {
              "form-id": _setup.formId,
              "show-archive-btn": true,
              "show-duplicate-btn": true,
              "show-history-btn": true,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }